import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { ModalController, ToastController } from '@ionic/angular';
import { ControllerService } from 'src/app/services/controller.service';

@Component({
  selector: 'app-modal-select-file-payment-proof',
  templateUrl: './modal-select-file-payment-proof.component.html',
  styleUrls: ['./modal-select-file-payment-proof.component.scss'],
})
export class ModalSelectFilePaymentProofComponent implements OnInit {
  @ViewChild('modalBox') modalBox: ElementRef<HTMLDivElement>;

  payment_proof_base64: string;

  constructor(
    private modalController: ModalController,
    private toastController: ToastController,
    private sanitizer: DomSanitizer,
    private controllerService: ControllerService,
  ) {}

  ngOnInit() {}

  onSubmit() {
    if (!this.payment_proof_base64) {
      return;
    }

    this.modalController.dismiss({ base64: this.payment_proof_base64 }, 'confirm');
  }

  async onUploadImage() {
    const platform = Capacitor.getPlatform();
    const isNative = platform === 'android' || platform === 'ios';

    const image = await Camera.getPhoto({
      quality: 40,
      allowEditing: false,
      resultType: CameraResultType.Base64,
      source: isNative ? CameraSource.Prompt : CameraSource.Photos,
    });

    if (image.base64String.length > 2_000_000) {
      this.controllerService.presentToast({
        message: 'Ukuran file tidak boleh lebih dari 2MB',
        color: 'danger',
        duration: 3000,
      });
      return;
    }

    this.payment_proof_base64 = image.base64String;
  }

  removeImage() {
    this.payment_proof_base64 = null;
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  protected async presentToast(message: string, duration: number = 1000, color: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
      color: color ?? null,
    });
    return await toast.present();
  }
}
